(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8028],{

/***/ 16689:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/prism-survival-analysis",
      function () {
        return __webpack_require__(30108);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ SurvivalAnalysis; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/PostElement/index.js + 4 modules
var PostElement = __webpack_require__(22857);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js + 1 modules
var Hero = __webpack_require__(69591);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Title.js
var Title = __webpack_require__(91319);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Description.js
var Description = __webpack_require__(50410);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Grid.js
var Hero_Grid = __webpack_require__(36432);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/HeroBackground.js
var HeroBackground = __webpack_require__(30389);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Action.js
var Action = __webpack_require__(14593);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/ButtonLink.js
var ButtonLink = __webpack_require__(85765);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Meta.js
var Meta = __webpack_require__(1041);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/Image.js
var Feature_Image = __webpack_require__(66176);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Feature/index.js + 1 modules
var Feature = __webpack_require__(55185);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r2/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(93816);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSectionStripped.js
var SimpleSectionStripped = __webpack_require__(37045);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Box/index.js + 1 modules
var Box = __webpack_require__(98746);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/PageMeta/index.js
var PageMeta = __webpack_require__(93890);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js + 1 modules
var UList = __webpack_require__(51192);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/pipe.js
var pipe = __webpack_require__(75833);
// EXTERNAL MODULE: ./src/SiteLayout/index.js + 2 modules
var SiteLayout = __webpack_require__(6533);
// EXTERNAL MODULE: ./src/InvolveYourTeam/index.js
var InvolveYourTeam = __webpack_require__(62121);
// EXTERNAL MODULE: ./src/services/index.js + 19 modules
var services = __webpack_require__(85783);
// EXTERNAL MODULE: ./src/SectionStart30DayTrial/index.js
var SectionStart30DayTrial = __webpack_require__(87666);
// EXTERNAL MODULE: ./src/AppError/withErrorHandling.js
var withErrorHandling = __webpack_require__(71802);
;// CONCATENATED MODULE: ./src/Apps/SurvivalAnalysis/index.js





























const CompanyPage = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("survival-analysis");
    const siteDomain = "www.graphpad.com";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SiteLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageMeta/* default */.ZP, {
                title: t("META_TITLE"),
                description: t("META_DESCRIPTION"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.OGP */.ZP.OGP, {
                        title: t("META_TITLE"),
                        description: t("META_DESCRIPTION"),
                        url: "https://www.".concat(siteDomain, "/features/prism-survival-analysis"),
                        image: "/images/graphpad/logo/logo-graphpad-dotmatics.png",
                        isImageBaseUrl: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default.Canonical */.ZP.Canonical, {
                        href: "https://www.graphpad.com/features/prism-survival-analysis"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* default */.Z, {
                color: "gradient",
                align: "left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
                        children: t("HERO_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description/* default */.Z, {
                        children: t("HERO_SUBTITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Action/* default */.Z, {
                        center: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero_Grid/* HeroRow */.P, {
                            center: false,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Grid/* HeroCol */.Z, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                        href: "/demos/",
                                        children: t("HERO_START_A_FREE_TRIAL")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_Grid/* HeroCol */.Z, {
                                    shrink: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* default */.Z, {
                                        href: "/how-to-buy/",
                                        isOutline2: true,
                                        styleType: "info-light",
                                        children: t("HERO_PRICING_BUTTON")
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBackground/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/images/graphpad/survival-analysis/graphic-step-graph-576.png",
                            className: "h-60"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSectionStripped/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                    mx: true,
                    my: true,
                    utility: {
                        justify: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                                children: t("LEFT_BULLET_ELEMENT_1")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                            sm: 12,
                            md: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                utility: {
                                    bgColor: "black--02"
                                },
                                spacing: {
                                    py: 4,
                                    px: 8
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementParagraph */.DK, {
                                        children: t("RIGHT_BULLET_ELEMENT_1")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PostElement/* PostElementUl */.Nj, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                                children: t("RIGHT_BULLET_ELEMENT_2")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                                children: t("RIGHT_BULLET_ELEMENT_3")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementListItem */.yv, {
                                                children: t("RIGHT_BULLET_ELEMENT_4")
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                isDark: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        children: t("SURVIVAL_ANALYSES_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.DescriptionV2 */.Z.DescriptionV2, {
                        children: t("SURVIVAL_ANALYSES_SUBTITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                            mx: true,
                            my: true,
                            utility: {
                                justify: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    sm: 12,
                                    md: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            utility: {
                                                bgColor: "white"
                                            },
                                            shadow: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: "/images/graphpad/survival-analysis/kaplan-meier.gif"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "xxxl"
                                            },
                                            children: t("WISTIA_1_SUBTEXT_1")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            children: t("WISTIA_1_SUBTEXT_2")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
                                    sm: 12,
                                    md: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            utility: {
                                                bgColor: "white"
                                            },
                                            shadow: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                src: "/images/graphpad/survival-analysis/cox-regression.gif"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            sx: {
                                                fontSize: "xxxl"
                                            },
                                            children: t("WISTIA_2_SUBTEXT_1")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                            children: t("WISTIA_2_SUBTEXT_2")
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        children: t("PERFORMING_SIMPLE_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.DescriptionV2 */.Z.DescriptionV2, {
                        children: t("PERFORMING_SIMPLE_SUBTITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSection/* default.Body */.Z.Body, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                top: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        numberItem: "1",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("STEPPER_TITLE_1")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: t("STEPPER_DESCRIPTION_1")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature_Image/* default */.Z, {
                                        src: "/images/graphpad/survival-analysis/survival-in-Prism-Step-1-w800.jpg",
                                        shadow: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                top: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        numberItem: "2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("STEPPER_TITLE_2")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Description */.Z.Description, {
                                                children: t("STEPPER_DESCRIPTION_2")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature_Image/* default */.Z, {
                                        src: "/images/graphpad/survival-analysis/survival-in-Prism-Step-2-w800.jpg",
                                        shadow: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Feature/* default */.Z, {
                                top: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default */.Z, {
                                        numberItem: "3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta/* default.Title */.Z.Title, {
                                                children: t("STEPPER_TITLE_3")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Meta/* default.Description */.Z.Description, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        children: t("STEPPER_DESCRIPTION_3")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                        children: t("STEPPER_DESCRIPTION_3_2")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UList/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                children: t("STEPPER_DESCRIPTION_3_3")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                children: t("STEPPER_DESCRIPTION_3_4")
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UList/* default.Item */.Z.Item, {
                                                                children: t("STEPPER_DESCRIPTION_3_5")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Feature_Image/* default */.Z, {
                                        src: "/images/graphpad/survival-analysis/survival-in-Prism-Step-3-w800.jpg",
                                        shadow: true
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InvolveYourTeam/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SimpleSectionStripped/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostElement/* PostElementLine */.ju, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.TitleV2 */.Z.TitleV2, {
                        children: t("ACCESS_OTHER_SURVIVAL_TITLE")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Body */.Z.Body, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Row */.X2, {
                            mx: true,
                            my: true,
                            utility: {
                                justify: "center"
                            },
                            spacing: {
                                my: 10
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                    sm: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://go.graphpad.com/video/understanding-kaplan-meier",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            className: "w-100",
                                            src: "/images/graphpad/anova/survival-kaplan-meier-w1146-800.png"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                    sm: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://www.graphpad.com/guides/survival-analysis",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            className: "w-100",
                                            src: "/images/graphpad/anova/survival-prism-survival-w1146-800.png"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                    sm: 12,
                                    md: 4,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "https://go.graphpad.com/video/cox-proportional-hazards-regression-analysis",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            className: "w-100",
                                            src: "/images/graphpad/anova/survival-cox-proportional-w1146-800.png"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionStart30DayTrial/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var SurvivalAnalysis = ((0,pipe/* default */.Z)(CompanyPage, withErrorHandling/* default */.Z, services/* default */.ZP));

;// CONCATENATED MODULE: ./pages/features/prism-survival-analysis.js



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8363,3556,5955,6533,4313,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(16689); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);